import react, { createContext, useState } from "react";

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
    const [dashboardData, setDashboardData] = useState({
        template: 0,
        certificate: 0,
        certificateSize:0
    });
  // console.log("dashboardData", dashboardData)
    return (
      <DashboardContext.Provider value={ { dashboardData ,  setDashboardData } }>
        {children}
      </DashboardContext.Provider>
    );
  };